import React from 'react';

export const Impressum = () => {
  // Holt die aktuelle Sprache (Standard: Deutsch)
  const currentLang = localStorage.getItem("project_lang") || "de";

  return (
    /* pt-28 sorgt für den nötigen Sicherheitsabstand zum Header */
    <div className="w-full max-w-4xl mx-auto px-6 pt-28 pb-12 text-[#E8DDC8]">
      <h1 className="serif text-4xl text-[#C9A227] mb-8">
        {currentLang === "en" ? "Legal Notice" : "Impressum"}
      </h1>

      <div className="space-y-6 text-sm tracking-wide leading-relaxed">
        {/* 1. Allgemeine Angaben gemäß § 5 DDG */}
        <section>
          <h2 className="text-[#C9A227] uppercase tracking-wider text-xs mb-2">
            {currentLang === "en"
              ? "Information according to § 5 DDG"
              : "Angaben gemäß § 5 DDG"}
          </h2>

          <p>Anne-Celine Friesecke</p>
          <p>Waldecker Straße 19</p>
          <p>60433 Frankfurt am Main</p>
        </section>

        {/* 2. Kontakt */}
        <section>
          <h2 className="text-[#C9A227] uppercase tracking-wider text-xs mb-2">
            {currentLang === "en" ? "Contact" : "Kontakt"}
          </h2>

          <p>
            E-Mail:{" "}
            <a
              href="mailto:a.c.friesecke@gmail.com"
              className="underline text-[#C9A227] hover:opacity-80"
            >
              a.c.friesecke@gmail.com
            </a>
          </p>
        </section>

        {/* 3. Redaktionell Verantwortliche */}
        <section>
          <h2 className="text-[#C9A227] uppercase tracking-wider text-xs mb-2">
            {currentLang === "en"
              ? "Editorial Responsibility"
              : "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV"}
          </h2>

          <p>Anne-Celine Friesecke</p>
          <p>Waldecker Straße 19</p>
          <p>60433 Frankfurt am Main</p>
        </section>

        {/* 4. Verbraucherschlichtung */}
        <section>
          <h2 className="text-[#C9A227] uppercase tracking-wider text-xs mb-2">
            {currentLang === "en"
              ? "Consumer Dispute Resolution"
              : "Verbraucherschlichtung"}
          </h2>

          <p>
            {currentLang === "en"
              ? "I am neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board."
              : "Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen."}
          </p>
        </section>

        <hr className="border-[#C9A227]/20 my-6" />

        {/* 5. Rechtliche Hinweise */}
        <section className="space-y-4 opacity-80 text-xs">
          <div>
            <h3 className="text-[#C9A227] font-medium mb-2">
              {currentLang === "en"
                ? "Liability for Content"
                : "Haftung für Inhalte"}
            </h3>

            <p>
              {currentLang === "en"
                ? "As the operator of this website, I am responsible for my own content on these pages in accordance with general laws. I am not obliged to monitor transmitted or stored third-party information."
                : "Als Betreiberin dieser Website bin ich für meine eigenen Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Ich bin jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen."}
            </p>
          </div>

          <div>
            <h3 className="text-[#C9A227] font-medium mb-1">
              {currentLang === "en"
                ? "Liability for External Links"
                : "Haftung für Links"}
            </h3>

            <p>
              {currentLang === "en"
                ? "This website may contain links to external third-party websites. I have no influence over their content and therefore cannot assume any liability for that content. The respective providers or operators are responsible for the content of linked websites."
                : "Mein Angebot kann Links zu externen Websites Dritter enthalten, auf deren Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden Inhalte keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten sind stets die jeweiligen Anbietenden oder Betreibenden der Seiten verantwortlich."}
            </p>
          </div>

          <div>
            <h3 className="text-[#C9A227] font-medium mb-1">
              {currentLang === "en" ? "Copyright" : "Urheberrecht"}
            </h3>

            <p>
              {currentLang === "en"
                ? "The content and works created by the website operator are subject to German copyright law. Any duplication, processing, distribution, or other use outside the limits of copyright law requires the prior written consent of the respective author or creator."
                : "Die von mir erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der vorherigen schriftlichen Zustimmung der jeweiligen Autorin bzw. Erstellerin."}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};